import React from 'react';
import {NavLink} from 'react-router-dom';
import {Translate, useTranslation} from '../../config/TranslationProvider';
import {isAbsoluteUrl} from '../../helper';
import CopyrightedImage from '../partials/CopyrightedImage';

const HostInfo = ({host}) => {

    const image = host.medialist[0];

    let url = '';
    if (host.url) {
        const href = host.url;
        url = isAbsoluteUrl(href) ? href : 'http://' + href;
    }

    return (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h2 className="h4"><span className="la la-user" />&nbsp;<Translate value="host" /></h2>
            </div>
            <div className="widget-body atbd_author_info_widget">
                <div className="atbd_avatar_wrapper">
                    <figure>
                        {image && <CopyrightedImage image={image} size="large" alt="event_image" />}
                    </figure>
                    <div className="atbd_name_time">
                        <h3 className="h4">{host.title}</h3>
                    </div>
                </div>
                <div className="atbd_widget_contact_info">
                    <ul>
                        {host.location?.address && (
                            <li>
                                <span className="la la-map-marker" />
                                <span className="atbd_info">{host.location.address}</span>
                            </li>
                        )}
                        {host.telephone && (
                            <li>
                                <span className="la la-phone" />
                                <span className="atbd_info">{host.telephone}</span>
                            </li>
                        )}
                        {host.email && (
                            <li>
                                <span className="la la-envelope" />
                                <span className="atbd_info">
                                    <a
                                        href={'mailto:' + host.email}
                                        target="_parent"
                                    >
                                        {host.email}
                                    </a>
                                </span>
                            </li>
                        )}
                        {host.url && (
                            <li>
                                <span className="la la-globe" />
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="atbd_info"
                                >
                                    {host.url}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
                <NavLink
                    to={'/hosts/' + host.id}
                    className="btn btn-outline-secondary btn-block"
                    aria-label={useTranslation('find_out_more_host')}
                >
                    <Translate value="find_out_more" />
                </NavLink>
            </div>
        </div>
    );
};

export default HostInfo;
